module.exports = __webpack_public_path__ + "static/media/Expand.cb430c15.svg";